// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"58acc3dd","239":"e538c99e","455":"7d60ec73","618":"7c79cb0c"}[chunkId] + ".chunk.js";
};